import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AccountActions } from '@portal/actions';

import ProfileInformation from '@portal/components/ProfileInformation/ProfileInformation';

import AdvancedHeader from '@portal/components/AdvancedHeader/AdvancedHeader';
import AdvancedPanelContentHeader from '@portal/components/AdvancedPanelContentHeader/AdvancedPanelContentHeader';
import { getRouteStackPath } from '@portal/config/routes';
import { useNavigation } from '@portal/hooks/useNavigation';
import useReduxState from '@portal/hooks/useReduxState';
import { PaymentAccountType } from '@portal/models/enumerators/paymentAccount';
import { translate } from '@portal/services/i18n';
import { getPaymentAccountByType } from '@portal/utils/paymentAccount';
import * as Sentry from '@sentry/react';

const PersonalInformation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigation();
  const {
    user: { me },
  } = useReduxState();
  const loggedUser = me;

  const [code, setCode] = useState('');

  useEffect(() => {
    const referralCode = loggedUser.account.settings?.find(
      (code) => code.key === 'ACCOUNT_REFERRAL_CODE'
    );

    setCode(referralCode?.value || '');
  }, [loggedUser.account.settings]);

  const paymentAccount = getPaymentAccountByType(
    loggedUser,
    PaymentAccountType.ACCOUNT
  );
  const handleChangePicture: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    if (event.target.files && event.target.files[0]) {
      event.target.files[0]
        .arrayBuffer()
        .then((buffer) => {
          dispatch(AccountActions.updateProfilePhoto(Buffer.from(buffer)));
        })
        .catch((error) => {
          Sentry.captureException(error, {
            extra: { context: 'PersonalInformation.handleChangePicture' },
          });
        });
    }
  };

  return (
    <>
      <AdvancedHeader
        title={translate('APPLICATION.TITLE')}
        showBreadCrumbs
        breadCrumbs={[
          {
            title: translate('PAGES.HOME.PAY.BREADCRUMB.HOME'),
            url: getRouteStackPath('HOME', 'HOME_PAGE'),
            active: true,
          },
          {
            title: translate('COMPONENTS.BREADCRUMB.MY_ACCOUNT'),
            url: getRouteStackPath('PROFILE', 'PROFILE_PAGE'),
            active: true,
          },
          {
            title: translate('COMPONENTS.BREADCRUMB.PROFILE'),
            active: false,
          },
        ]}
      />
      <div className="personal-information">
        <AdvancedPanelContentHeader
          testId="personal-information-header"
          title={translate('COMPONENTS.BREADCRUMB.PROFILE')}
          description={translate('PAGES.MY_ACCOUNT.PROFILE.DESCRIPTION')}
          goBackAction={() => navigate.back()}
        />
        <ProfileInformation
          name={me?.name ?? ''}
          email={me?.email ?? ''}
          taxIdentifier={me?.account.taxIdentifier ?? ''}
          cellphone={me?.cellphone ?? ''}
          motherName={me?.account.motherName ?? ''}
          bornAt={me?.account.bornAt ?? ''}
          photoUrl={
            me?.impersonatorAccount
              ? me?.impersonatorAccount?.photoUrl
              : me.account.photoUrl
          }
          accountType={me?.account.type ?? ''}
          account={paymentAccount?.bankAccount ?? ''}
          branch={paymentAccount?.bankBranchAccount?.padStart(4, '0') ?? ''}
          onChangePictureClick={handleChangePicture}
          referralCode={code ?? ''}
          bankNumber={paymentAccount?.bankNumber ?? ''}
        />
      </div>
    </>
  );
};

export default PersonalInformation;
